import { AssetIcon } from "../assets/Icon.js";
import { useT } from "../i18n/index.js";
import { Timer } from "../ui/Timer.js";
import { useBase } from "./state.js";
import { buildingName } from "./panels/shared.js";
import "./construction.css";

/** A named, permanently visible entry beside the independently scrolling base statistics. */
export function ConstructionSummary() {
  const t = useT(), base = useBase((state) => state.base);
  if (!base) return null;
  const next = base.buildings.filter(building => building.state !== "idle" && building.finishesAt !== null).sort((a, b) => a.finishesAt! - b.finishesAt!)[0];
  const queue = base.queues.build;
  return <button type="button" className="construction-summary" onClick={() => useBase.getState().setPanel({ kind: "queue" })} data-testid="chip-queue">
    <AssetIcon id={next?.buildingId ?? "bld.workshop"} size={32} alt="" />
    <span className="construction-summary-copy">
      <strong>{t("base.queue.build")} <span className="construction-count">{queue.used}/{queue.slots}</span></strong>
      {next ? <span className="construction-next"><span title={buildingName(next.buildingId)}>{buildingName(next.buildingId)}</span><Timer finishesAt={next.finishesAt!} className="timer" /></span> : <span>{t("base.queue.freeBuilders", { n: Math.max(0, queue.slots - queue.used) })}</span>}
    </span>
  </button>;
}
